import footerReducer from "./reducers/footerReducer";
import { configureStore } from "@reduxjs/toolkit";

import menuReducer from "./reducers/menuReducers";
import orderReducer from "./reducers/orderReducers";
import paymentReducer from "./reducers/paymentReducers";
import priceReducer from "./reducers/priceReducers";
import themeReducer from "./reducers/themeReducers";
import sessionReducer from "./reducers/sessionReducer";


const store = configureStore({
  reducer: {

    menu: menuReducer,

    order: orderReducer,

    payment: paymentReducer,

    price: priceReducer,

    theme: themeReducer,

    session: sessionReducer,
    footer: footerReducer

  },
});

export default store;